<template>
  <div>
    <HeaderComponent :menu-id="6"></HeaderComponent>
    <div style="background-color: #FFFFFF;">
      <div class="peifu-container" style="padding-bottom: 0px;">
        <!-- 标题 -->
        <div class="title-ty" style="padding-bottom: 50px;">
          <div class="title-ty-y">SHUISHI GRADING</div>
          <div class="title-ty-z"><span>水石评级</span>公示公告</div>
        </div>
        <div class="peifu-box" style="padding-bottom: 0px;">
          <p class="p-ty">1、因铸造原因造成钱体的轻微不平，水石评级不加备注。存储原因造成的钱体不平，根据其不平程度，备注钱体不平，或轻微不平，不备注极轻微不平。</p>
          <p class="p-ty">2、可视铸造瑕疵，如单面铸纹、铸纹已透、铸缺、铸坑、气孔不透等水石评级不加备注。关于较为严重的铸造瑕疵给予备注或瑕疵代码。(不包括穿口的铸裂纹)。</p>
          <p class="p-ty">3、对钱币土、锈、污垢进行的清理，水石评级不加备注。清理≠加刀。</p>
          <p class="p-ty">4、关于钱体加刀，严重加刀的水石评级给于真品或瑕疵代码，局部加刀或轻微加刀，会加详细备注。</p>
          <p class="p-ty">5、水石评级会对单面牛毛纹，牛毛纹，龟裂纹，做详细备注;钱体边缘的表皮极小裂纹可不加备注。</p>
          <p class="p-ty">6、关于钱体严重打磨，以及严重清洗，钱体有锈蚀等水石评级会做详细备注。</p>
        </div>
      </div>
    </div>
    <!-- <div style="background-color: #F4F5F9;padding: 20px 0 100px;">
      <div class="peifu-box">
        <div class="gonggao-text">水石评级将最大程度地对评级标准进行优化，既能达到藏家的知情权，又不影响钱币本身价值。</div>
        <div class="gonggao-s" style="margin: 40px 0 10px;">注:最终解释权归水石评级所有</div>
        <div class="gonggao-s">2026年3月30日</div>
      </div>
    </div> -->
    <img src="@/assets/image/gongshigonggao.jpg" alt="" style="width: 100%;">
    <FooterComponent></FooterComponent>
  </div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue'
import FooterComponent from '@/components/FooterComponent.vue'

export default {
  data() {
    return {
    }
  },
  methods: {
  },
  components: {
    HeaderComponent,
    FooterComponent
  },
  created() {
  },
}
</script>
<style lang="less" scoped>
.gonggao-text{
  font-size: 26px;
  font-weight: bold; 
  letter-spacing: 3px; 
  line-height: 45px;
}
.gonggao-s{
  font-size: 17px; 
  text-align: right;
  letter-spacing: 2px;
}
</style>